import React, { useState } from 'react';

import AddTodo from './components/AddTodo';
import TodoList from './components/TodoList';
import HideControlCheckBox from './components/HideControlCheckBox';

import './App.scss';
import './load-font-awesome';

import initialTodos from './assets/initial-todos.json';

function App() {
  const [todos, updateTodos] = useState(initialTodos);
  const [hideComplete, updateHideComplete] = useState(false);

  const onAddTodo = (title) => {
    const id = todos.length;
    const todo = { key: id, id, title, isComplete: false };
    updateTodos(todos.concat(todo));
  };

  const onCompleteTodo = (id, flag) => {
    const todo = todos.find((todo) => todo.id === id);
    todo.isComplete = flag;
    updateTodos([...todos]);
  };

  return (
    <div className="App">
      <h1 style={{ color: 'grey' }}>하긴 해야 되는데, 뭐부터 할까?</h1>
      <div>
        <HideControlCheckBox onChange={updateHideComplete} />
      </div>
      <div>
        <AddTodo onConfirm={onAddTodo} />
        <TodoList
          todos={todos}
          setComplete={onCompleteTodo}
          hideComplete={hideComplete}
        />
      </div>
    </div>
  );
}

export default App;
